import { useEffect, useState } from 'react';
import { useDepsMatchingCallbackRef } from 'src/utils/react/deps-matching-callback-ref.hook';
import { apiGetAllJourneysInsights } from 'src/utils/journeyApi';
import { JourneyMetrics, TimePeriodParam } from '../constants';
import { useCurrentOrganization } from 'src/store/organization';

type Params = {
  journeyId?: number;
  filters?: {
    session_uuid?: string;
    time_period?: TimePeriodParam;
  };
};

export const useJourneyMetrics = ({ journeyId, filters }: Params) => {
  const { currentOrganization } = useCurrentOrganization();
  const [fetching, setFetching] = useState(true);
  const [metrics, setMetrics] = useState<JourneyMetrics>();

  const onFetchJourneyMetricsRef = useDepsMatchingCallbackRef(
    (response: any) => {
      setMetrics(response.insights[0] as JourneyMetrics);
      setFetching(false);
    },
    [currentOrganization.id, journeyId, filters]
  );

  useEffect(() => {
    const fetchJourneyMetrics = async () => {
      setFetching(true);
      if (journeyId && currentOrganization) {
        const { session_uuid, time_period } = filters || {};
        const response = await apiGetAllJourneysInsights(currentOrganization.id, {
          journey_id: journeyId,
          ...(session_uuid && { session_uuid }),
          ...(time_period && { time_period }),
        });
        onFetchJourneyMetricsRef.current &&
          onFetchJourneyMetricsRef.current(response, [currentOrganization.id, journeyId, filters]);
      }
    };
    fetchJourneyMetrics();
  }, [currentOrganization.id, journeyId, filters]);

  return { fetching, metrics };
};
